import { Button } from 'alurkerja-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { ChevronDown, ChevronLeft } from 'lucide-react';
import { Fragment } from 'react';
import moment from 'moment';
import { useFetch } from '@/hooks/useFetch';
import { DetailApplication } from '@/utils/types/permit';
import { Section } from '@/components/shared/section/Section';
import { isBase64 } from '@/utils/functions/isBase64';

export const HistoryTask = () => {
  const navigate = useNavigate();
  const params = useParams();

  const { data } = useFetch<DetailApplication>({
    path: `/workflow/v1/bpmn/${params.bpmnProcessId}/${params.instanceID}`,
  });

  const actionButton = () => (
    <div className="flex items-center gap-4">
      <Button icon={<ChevronLeft size={12} />} onClick={() => navigate(-1)}>
        Back
      </Button>
      History
    </div>
  );

  return (
    <div className="border rounded">
      <Section title="Task" action={actionButton}>
        <div className="grid gap-4 p-6">
          {data?.finished_tasks.map((task, idx) => (
            <details className="p-6 border rounded cursor-pointer hover:bg-gray-50" key={`task-${idx}`}>
              <summary className="grid grid-cols-2 list-none">
                <div className="font-medium">
                  {moment.unix(Math.floor(task.timestamp / 1000)).format('DD MMMM YYYY - HH:mm')}
                </div>
                <div className="flex items-center justify-between">
                  <div>{task.value.elementId}</div>
                  <ChevronDown size={12} />
                </div>
              </summary>
              <div className="mt-4 p-2.5 border rounded-xl grid grid-cols-2">
                <div className="border-b px-3 py-2.5 font-bold">Variabel</div>
                <div className="border-b px-3 py-2.5 font-bold">Value</div>

                {Object.keys(task.value.variables).map((key, idx) => {
                  const className = idx % 2 === 0 ? 'px-3 py-2.5' : 'px-3 py-2.5  bg-[#e2e2e2]';
                  if (isBase64(task.value.variables[key])) {
                    return (
                      <Fragment key={key}>
                        <div className={className}>{key}</div>
                        <img src={task.value.variables[key]} alt="lampiran" />
                      </Fragment>
                    );
                  }
                  return (
                    <Fragment key={key}>
                      <div className={className}>{key}</div>

                      <div className={className}>{task.value.variables[key]}</div>
                    </Fragment>
                  );
                })}
              </div>
            </details>
          ))}
        </div>
      </Section>
    </div>
  );
};
